import { CohortType } from '@prisma/client';
import { RealmRole } from '@web/common';
import { navItems } from './navigationItems';

// nachversandEligible comes from /users/me: only an explicit true passes
export const getNavItemsForRole = (
  role: RealmRole,
  cohortType?: CohortType | null,
  nachversandEligible: boolean | null = null,
) =>
  navItems
    .filter((item) => item.role.includes(role))
    .filter(
      (item) =>
        item.cohortType === undefined ||
        (!!cohortType && item.cohortType?.includes(cohortType)),
    )
    .filter(
      (item) =>
        !item.requiresNachversandEligible || nachversandEligible === true,
    );
